
import { Component, Prop, Vue } from 'vue-property-decorator';

/**
 * N-291 (T5): lo que se ve en una ficha mientras carga. Antes seis fichas tenían el «Cargando» DENTRO del
 * `v-if="!loading"`: salían en blanco, sin flecha para cerrar, y si la carga fallaba se quedaban así.
 */
@Component({})
export default class CargandoFicha extends Vue {
	@Prop({ default: '' }) private titulo!: string;
	@Prop({ default: false }) private fallo!: boolean;
}
